import React from 'react';

import Profile from '../asset/profil.jpg';
import ui from '../asset/uiux.png';
import react from '../asset/nodejs.png';
import node from '../asset/reactjs.png';

const About = () => {
    return (
        <section id="about" className="py-20" style={{ backgroundColor: 'rgba(12, 24, 38, 1)', borderTop: '1px solid white', borderBottom: '1px solid white' }}>
            <div className="container mx-auto text-center px-6">
                <h2 className="text-4xl font-semibold mb-10 text-white">
                    About Me
                </h2>

                <div className="flex flex-col items-center mb-12">
                    <img src={`${Profile}`} alt="Profile Picture" className="w-32 h-32 rounded-full object-cover mb-4 shadow-lg"/>
                    <p className="text-2xl text-rose-700 mb-2 font-semibold">Student & Software Engineer</p>
                    <p className="text-3xl text-white font-medium">I am a Student and a freelance software engineer</p>
                </div>

                <div className="grid grid-cols-1  md-grid-cols-2 lg:grid-cols-3 gap-8">
                    <div className="bg-slate-700 p-6 rounded-lg shadow-lg hover:bg-slate-500 transition-colors duration-300" style={{
                       boxShadow: '0px 0px 15px 5px rgba(43, 59, 78, 1)',
                   }}>
                    <img src={`${react}`} alt='reactjs' className="w-20 h-30"/>
                    <h3 className="text-2xl font-bold mb-2 text-white text-left">ReactJS</h3>
                    <p className="text-white mb-4 text-left">
                    React is a popular JavaScript library used to build fast, scalable, and component-based interactive user interfaces for web and mobile applications.</p>
                    </div>

                    <div className="bg-slate-700 p-6 rounded-lg shadow-lg hover:bg-slate-500 transition-colors duration-300" style={{
                       boxShadow: '0px 0px 15px 5px rgba(43, 59, 78, 1)',
                   }}>
                    <img src={`${ui}`} alt='reactjs' className="w-30 h-20"/>
                    <h3 className="text-2xl font-bold mb-2 text-white text-left">UI/UX</h3>
                    <p className="text-white mb-4 text-left">UI/UX is the user interface and experience, which includes visual and interaction design as well as overall experience and convenience. use.</p>
                    </div>

                    <div className="bg-slate-700 p-6 rounded-lg shadow-lg hover:bg-slate-500 transition-colors duration-300" style={{
                       boxShadow: '0px 0px 15px 5px rgba(43, 59, 78, 1)',
                   }}>
                    <img src={`${node}`} alt='reactjs' className="w-20 h-30"/>
                    <h3 className="text-2xl font-bold mb-2 text-white text-left">NodeJS</h3>
                    <p className="text-white mb-4 text-left">Node.js is a runtime for a JavaScript environment outside the web browser built on top of the JavaScript engine.</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About;